import { Locale } from 'modules/i18n';

export const buttonsTranslation = {
  [Locale.en]: {
    manage: 'Manage',
  },
};
